export default {
  ROUTES: {
    COMPARE: { NAME: 'compare', PATH: '/compare' },
  },
}
